/**
 * hexColor turns a stored color into something css can paint, or null when
 * there is nothing paintable yet - a half typed value, or none at all.
 *
 * Colors are stored as bare hex digits, which is what the API accepts, so the
 * leading hash is added here rather than kept in the data.
 */
export function hexColor(raw: string | null | undefined): string | null {
  if (!raw) {
    return null
  }

  const digits = raw.trim().replace(/^#/, "")
  if (!/^[0-9a-fA-F]{3}$|^[0-9a-fA-F]{6}$/.test(digits)) {
    return null
  }

  return `#${digits}`
}

/**
 * normalizeHexInput keeps what gets stored to the bare hex digits the API
 * accepts, so pasting a color straight out of a design tool does not fail
 * validation on save.
 */
export function normalizeHexInput(raw: string): string {
  return raw.trim().replace(/^#/, "")
}
